module.exports = __webpack_public_path__ + "static/img/06.3c8c1e44.jpg";